import { type PlanLimit } from '@prisma/client'

function formatRetention(days: number): string {
	if (days === 365) return '1 an de rétention'
	if (days > 0 && days % 365 === 0)
		return `${days / 365} ans de rétention`
	return `${days} jours de rétention`
}

export function formatPlanFeatures(plan: PlanLimit): string[] {
	const realtimeAlerts =
		plan.maxRealtimeAlerts === -1
			? 'Alertes temps réel illimitées'
			: `${plan.maxRealtimeAlerts} alerte${plan.maxRealtimeAlerts > 1 ? 's' : ''} temps réel`

	const alerts =
		plan.maxAlerts === -1
			? 'Alertes illimitées'
			: `${plan.maxAlerts} alerte${plan.maxAlerts > 1 ? 's' : ''}`

	const members =
		plan.maxMembers === -1 ? 'Membres illimités' : `${plan.maxMembers} membres`

	const sources =
		plan.maxSources === -1
			? 'Sources illimitées'
			: `${plan.maxSources} sources`

	const lists =
		plan.maxLists === -1
			? 'Listes illimitées'
			: `${plan.maxLists} listes de diffusion`

	return [
		realtimeAlerts,
		alerts,
		members,
		sources,
		lists,
		formatRetention(plan.retentionDays),
	]
}

export interface PlanPriceDisplay {
	monthly: number
	yearly: number
	yearlyTotal: number
	isCustom: boolean
}

export function formatPlanPrice(plan: PlanLimit): PlanPriceDisplay {
	return {
		monthly: plan.priceMonthly / 100,
		yearly: plan.priceYearly / 100 / 12,
		yearlyTotal: plan.priceYearly / 100,
		isCustom: plan.priceMonthly === 0,
	}
}
